import { queryDocuments } from '@lifetools/shared-database';
import { makeAsyncActionCreator } from 'services/store/utils-actions';
import firstRunOrAfterOldFailure from 'services/store/utils/actions/firstRunOrAfterOldFailure';
import { collection, types, statusTypes } from '../definitions';

const querySchedules = makeAsyncActionCreator({
  type: types.SET_SCHEDULES,
  when: firstRunOrAfterOldFailure,
  creator: async query => ({ schedules: await queryDocuments(collection, query) }),
  status: {
    path: collection,
    type: statusTypes.querySchedules,
  }
});

export default querySchedules;
